// Mobile menu: the burger slides the nav panel down; closing on link click,
// Escape and when growing past the desktop breakpoint.
import { $ } from "./dom.js";

export function initHeader() {
  const burger = $(".js-burger");
  const nav = $(".js-header-nav");
  if (!burger || !nav) return;

  const close = () => {
    nav.classList.remove("is-open");
    burger.setAttribute("aria-expanded", "false");
  };

  burger.addEventListener("click", () => {
    const open = nav.classList.toggle("is-open");
    burger.setAttribute("aria-expanded", open ? "true" : "false");
  });
  nav.addEventListener("click", (e) => {
    if (e.target.closest("a")) close();
  });
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") close();
  });
  window.addEventListener("resize", () => {
    if (window.innerWidth >= 992) close();
  });
}
